import { type KeyboardEvent, type ReactNode } from 'react';
import type { SearchOption } from './types';
import { DATE_FILTER_OPTIONS } from './utils';
import s from './grid-search.module.scss';

interface DateFilterOptionDropdownProps {
    onSelect: (option: SearchOption) => void;
    onKeyDown: (
        e: KeyboardEvent<HTMLButtonElement>,
        option: SearchOption,
    ) => void;
    options?: SearchOption[];
}

export function DateFilterOptionDropdown({
    onSelect,
    onKeyDown,
    options = DATE_FILTER_OPTIONS,
}: DateFilterOptionDropdownProps): ReactNode {
    return (
        <div className={s.dropdown} role="listbox">
            {options.map((opt) => (
                <button
                    key={opt.value}
                    type="button"
                    className={s.dropdownItem}
                    role="option"
                    aria-selected={false}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        onSelect(opt);
                    }}
                    onKeyDown={(e) => {
                        onKeyDown(e, opt);
                    }}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
